import { Component, Input, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'skychute-screen-loader',
    templateUrl: './screen-loader.component.html',
    styleUrls: ['./screen-loader.component.scss'],
    standalone: false
})
export class ScreenLoaderComponent {
  private domSanitizer = inject(DomSanitizer);
  data = inject<{
    title: string;
    content: SafeHtml | string;
}>(MAT_DIALOG_DATA);

  @Input() title = '';
  @Input() content: SafeHtml | string = '';

  constructor() {
    const data = this.data;

    this.title = data.title;
    if (typeof data.content === 'string') {
      this.content = this.domSanitizer.bypassSecurityTrustHtml(data.content);
    }
  }
}
